import { createSelector } from '@reduxjs/toolkit';
import { getDayPartMenuConfig } from './config';
import getItems from './getItems';
import checkStagePurchaseAvailability from '../utils/ordering/checkStagePurchaseAvailability';
import getOrderDateTimeSelected from './getOrderDateTimeSelected';
import getDayparts from './getDayparts';
import getMenu from './getMenu';
import getAllCategoryInfos from './getAllCategoryInfos';

export default (purchaseWithTotals?: PurchaseWithTotals) =>
  createSelector(
    [
      getDayPartMenuConfig,
      getItems,
      getOrderDateTimeSelected,
      getDayparts,
      getMenu,
      getAllCategoryInfos,
    ],
    (
      daypartConfig,
      items,
      dateTimeSelected,
      daypartSlots,
      menu,
      categoriesInfo,
    ): boolean => {
      return checkStagePurchaseAvailability(
        purchaseWithTotals,
        items,
        daypartConfig,
        dateTimeSelected,
        daypartSlots,
        menu?.rootMenuNode?.subMenus,
        categoriesInfo,
      );
    },
  );
